export const SLIDE_CONFIGS = [
  {
    id: "archetype",
    label: "YOUR MIRROR",
    duration: 6000,
    background: {
      color1: "#0f1f3d",
      color2: "#1a3a6b",
      inkColor: "rgba(100, 149, 237, 0.15)",
    },
    textColor: "#e8eef7",
    accentColor: "#7eb3f5",
  },
  {
    id: "shaped_by",
    label: "WHAT SHAPED YOU",
    duration: 8000,
    background: {
      color1: "#1a0f00",
      color2: "#3d2000",
      inkColor: "rgba(255, 160, 50, 0.12)",
    },
    textColor: "#f5e6d0",
    accentColor: "#f0a050",
  },
  {
    id: "costing_you",
    label: "WHAT IT COSTS",
    duration: 7000,
    background: {
      color1: "#1a0d12",
      color2: "#3d1020",
      inkColor: "rgba(180, 80, 100, 0.12)",
    },
    textColor: "#f5dde3",
    accentColor: "#d4788a",
  },
  {
    id: "question",
    label: "SIT WITH THIS",
    duration: 10000,
    background: {
      color1: "#0a1a0f",
      color2: "#0f2e18",
      inkColor: "rgba(80, 180, 100, 0.1)",
    },
    textColor: "#dff0e4",
    accentColor: "#7bc990",
  },
];

export const AUTO_ADVANCE_DEFAULT = true;
export const HOLD_THRESHOLD_MS = 200;
